<template>
  <div class>
    <header
      class="sticky-header"
      :class="{ 'second-level-active': secondLevelHeaderActive }"
    >
      <header-top />
      <template v-if="!secondLevelHeaderActive">
        <transition name="drop">
          <searchbar-vue v-if="displaySearch" :hide-search="hideSearch" />
        </transition>
        <div class="calc-continer edit-details-head">
          <div class="float-right header-icon-contain col-12-custom">
            <div class="col-12-custom view-appointment">
              <a
                id="edit-name-third"
                href="#"
                class="color-red"
                @click.stop.prevent="returnToDailyLocal"
              >
                <object
                  class="svg-back-arrow"
                  :data="backSvg"
                  type="image/svg+xml"
                ></object>
              </a>
              <span>{{ viewOrEdit }} Appointment</span>
            </div>
            <div
                class="col-4-custom"
                v-if="show && (detail.is_video !== 1 || detail.type == 2)"
            >
              <!-- <div
                class="col-4-custom"
                v-if="
                  show &&
                    (detail.is_video !== 1 ||
                      !deleteVideoAppointmentPermissionRefused)
                "
              > -->
              <a
                id="edit-name-fourth"
                href="#"
                class="color-red pl-10"
                @click.prevent="popup('cancel')"
                v-if="this.detail && this.detail.is_cancelled !== 1"
                >Cancel</a
              >
              <a
                href="#"
                class="color-red pl-10"
                @click.prevent="popup('un-cancel')"
                v-else
                >Un-cancel</a
              >
            </div>
            <div
                class="col-4-custom text-center"
                v-if="
                  show && (detail.is_video !== 1 || detail.type == 2)
                "
            >
              <!-- <div
                class="col-4-custom text-center"
                v-if="
                  show &&
                    (detail.is_video !== 1 ||
                      !deleteVideoAppointmentPermissionRefused)
                "
              > -->
              <a
                href="#"
                id="edit-name-fifth"
                class="color-red"
                @click.prevent="popup('delete')"
                >Delete</a
              >
            </div>
            <div class="col-4-custom text-right" v-if="show">
              <a
                v-if="!getEdit.isEdit"
                href="#"
                class="color-red mr-15"
                @click.prevent.stop="setEditLocal"
                >Edit</a
              >

              <a
                v-if="(editLevel === 0 || editLevel >= 2) && getEdit.isEdit"
                href="#"
                class="color-red mr-15"
                @click.prevent="popupAdd"
                >Save</a
              >

              <span class="flex-input" @click="setFirstNameInitLocal">
                <label
                  v-if="
                    editLevel === 1 &&
                      getEdit.isEdit &&
                      getAppointmentType.removeOnRefresh.index ===
                        getAppointmentType.selectedIndex
                  "
                  ref="editName"
                  href="#"
                  for="name"
                  >Edit Name</label
                >
                <input
                  v-if="
                    editLevel === 1 &&
                      getEdit.isEdit &&
                      getAppointmentType.removeOnRefresh.index ===
                        getAppointmentType.selectedIndex
                  "
                  :value="inputName.firstName"
                  class="hidden-input"
                  @input="setInputLocal"
                  type="text"
                  autocomplete="off"
                  ref="hiddenInput"
                  @keydown.enter="addPersonOrEvent('enter')"
                  @blur="addPersonOrEvent('blur')"
                />
              </span>
            </div>
          </div>
        </div>
      </template>

      <!-- Add toggles -->
      <template>
        <!-- Add person -->
        <transition name="drop">
          <add-person-toggle
            v-if="addOption === 'person'"
            :hide-drop-down="hideAddOption"
          />
        </transition>

        <!-- Add event -->
        <transition name="drop">
          <add-event-toggle
            v-show="addOption === 'event'"
            :hide-drop-down="hideAddOption"
          />
        </transition>

        <!-- Add group -->
        <transition name="drop">
          <add-group-toggle
            v-if="addOption === 'group'"
            :hide-drop-down="hideAddOption"
          />
        </transition>
      </template>
    </header>
  </div>
</template>

<script>
import SearchbarVue from "../common/Searchbar";
import HeaderTop from "../../common/HeaderTop";
import { addEditAppointmentHeaderMixin } from "../../../mixins/addEditAppointmentHeaderMixin";
import { mapGetters, mapMutations } from "vuex";
import { monthAndWeekMixin } from "../../../mixins/monthAndWeekMixin";
import { appointmentDetailMixin } from "../../../mixins/appointmentDetailMixin";
import { permissionMixin } from "../../../mixins/permissionMixin";
import { providerDependentMixin } from "../../../mixins/providerDependentMixin";

export default {
  mixins: [
    monthAndWeekMixin, // For month calendar
    appointmentDetailMixin, // For appointment details
    permissionMixin, // For permissions
    providerDependentMixin, // For provider data
    addEditAppointmentHeaderMixin // For edit appointment
  ], // Get an array of all the months
  data() {
    return {
      backSvg: require("../../../assets/svg/back.svg")
    };
  },
  props: {
    popup: Function, // Function to show the popup
    popupAdd: Function, // Function to show edit appointment popup
    editLevel: Number, // Current edit level
    editMode: Boolean, // Weather it is edit mode
    displaySearch: Boolean, // Weather to display search or not
    hideSearch: Function, //  Hide the search function
    addOption: String, // Which add option to show
    hideAddOption: Function // Hides the add option
  },
  computed: {
    ...mapGetters({
      deleteVideoAppointmentPermissionRefused:
        "getDeleteVideoAppointmentPermissionRefused",
      details: "getDetail",
      getEdit: "getEdit",
      showResultsNow: "getShowResultsNow",
      previousRoute: "getPreviousRoute",
      secondLevelHeaderActive: "getSecondLevelHeaderActive",
      hideBackAndAddButton: "getHideBackAndAddButton"
    }),
    ...mapGetters("addNew", {
      inputName: "getName"
    }),
    newName() {
      return this.inputName.firstName;
    },
    viewOrEdit() {
      return this.editMode === false ? "View" : "Edit";
    }
  },
  methods: {
    ...mapMutations("addNew", {
      setFirstName: "setFirstName"
    }),
    ...mapMutations({
      removeTemporaryEvent: "removeTemporaryEvent",
      addToEventListInForm: "addToEventListInForm",
      preventRemoveResults: "preventRemoveResults"
    }),
    /**
     * Goto add appointment component and set it up for editing
     */
    setEditLocal() {
      if (this.id && this.detail) {
        // Step 1: Setting current day month and year for app_date
        const yearMonthDate = this.currentYearMonthDate;
        this.setYear(yearMonthDate.year);
        this.setMonth(yearMonthDate.month);
        this.setDayOfMonth(yearMonthDate.dayOfMonth);

        // Step 2: Setting edit to modify add appointment
        this.setEdit({
          id: this.id,
          appointment: this.detail
        });
      }
    },
    /**
     * Set the name input
     */
    setInputLocal(event) {
      this.setFirstName(event.target.value);
    },
    /**
     * Save a temporaty event
     */
    saveTempEvent() {
      if (this.newName.trim().length > 0) {
        this.removeTemporaryEvent();
        this.addToEventListInForm({
          event: { id: 0, name: this.newName.trim() },
          providerId: this.selectedProviderId,
          onlyThis: true
        });
      }
    },
    /**
     * Add person or event
     */
    addPersonOrEvent(value) {
      setTimeout(() => {
        // Step 1: Check if blured to more priority elements
        if (value === "blur") {
          const secInput = document.getElementById("edit-name-second");
          const thirdInput = document.getElementById("edit-name-third");
          const fourthInput = document.getElementById("edit-name-fourth");
          const fifthInput = document.getElementById("edit-name-fifth");
          if (
            document.activeElement === secInput ||
            document.activeElement === thirdInput ||
            document.activeElement === fourthInput ||
            document.activeElement === fifthInput
          ) {
            return;
          }
        }

        // Step 2: Show popup if value is changed
        if (this.otherType === "event") {
          if (this.selectedValue !== this.newName) {
            this.saveTempEvent();
            this.popupAdd();
          }
        } else {
          if (this.selectedValue !== this.newName) {
            this.popupAdd(true);
          }
        }
      }, 0);
    },
    setFirstNameInitLocal() {
      this.setFirstName(this.selectedValue);
    },
    returnToDailyLocal() {
      if (this.showResultsNow) {
        this.preventRemoveResults();
      }
      if ("previousRoute" in this && this.previousRoute === "/") {
        this.$router.push("/daily");
        return;
      }
      this.$router.go(-1);
    }
  },
  components: {
    HeaderTop,
    SearchbarVue
  },
  mounted() {
    if (this.$refs.editName !== undefined) {
      this.$refs.editName.addEventListener("click", event => {
        event.target.parentElement.children[1].focus();
      });
    }
  },
  watch: {
    editLevel(value) {
      if (value === 1) {
        this.setFirstName(this.selectedValue);
      }
    }
  }
};
</script>

<style scoped>
header {
  background-color: white;
}

.second-level-active {
  z-index: 999 !important;
  min-height: 97px !important;
}

.remove-min-height {
  min-height: 0px !important;
}

.flex-input {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.flex-input label {
  color: #d26d13;
}

.hidden-input {
  position: absolute;
  opacity: 0;
  z-index: 999;
}

.mr-15 {
  margin-right: 15px !important;
}

.sticky-header {
  min-height: 127px;
}

.view-appointment {
  font-size: 20px;
}

.view-appointment span {
  display: inline-block;
  position: relative;
  left: calc(50% - 34px);
  transform: translateX(-50%);
  margin-bottom: 4px;
  bottom: 3px;
}
.view-appointment a {
  position: relative;
  bottom: 4px;
}
.pl-10 {
  padding-left: 10px !important;
}
.header-icon-contain {
  padding-top: 10px;
}
.calc-continer {
  margin-top: 50px;
}
</style>
